import React from 'react';
import TableBuy from './TableBuy';

const SalesReport = (props) => {
  return (
    <div className="fixed h-full w-full overflow-hidden max-w-screen-xl">
      <div className="bg-gray-300 opacity-50 h-full w-full absolute"></div>
      <div className="relative bg-white w-8/12 ml-32 opacity-100 pt-auto rounded-md">
        <div className="flex flex-col h-auto mt-16 overflow-scroll">
          <div className="flex justify-between items-center px-8 border-b border-gray-500 pb-4">
            <h5 className="mt-4 text-2xl text-gray-600 capitalize">
              Laporan Pembelian
            </h5>
            <button onClick={props.handdleClick} className="h-3 w-3">
              x
            </button>
          </div>
          <div
            className="bg-white flex flex-col px-8 py-3 overflow-y-scroll"
            style={{ height: '30rem' }}
          >
            <TableBuy />
          </div>
          {/* Footer Login */}
          {/* End Footer Login */}
        </div>
      </div>
    </div>
  );
};

export default SalesReport;
